module.exports = __webpack_public_path__ + "static/media/westinchennai02.9b6f8eb3.jpg";